import { BookingStatus } from '@/types/booking-management.types';

/** Message id for a booking status label on the harbour operator dashboard. */
export const getBookingStatusMessageId = (status: number): string => {
  switch (status) {
    case BookingStatus.PENDING:
      return 'DASHBOARD.STATUS.PENDING';
    case BookingStatus.CONFIRMED:
      return 'DASHBOARD.STATUS.CONFIRMED';
    case BookingStatus.CANCELLED:
      return 'DASHBOARD.STATUS.CANCELLED';
    case BookingStatus.COMPLETED:
      return 'DASHBOARD.STATUS.COMPLETED';
    case BookingStatus.PENDING_CONFIRMATION:
      return 'DASHBOARD.STATUS.PENDING_CONFIRMATION';
    case BookingStatus.REJECTED:
      return 'DASHBOARD.STATUS.REJECTED';
    default:
      return 'DASHBOARD.STATUS.UNKNOWN';
  }
};
